import { CatalogLightingFormPage } from './CatalogLightingFormPage';
import { LightingAdminPage } from './admin/LightingAdminPage';

export function LightingListPage() {
  return <LightingAdminPage />;
}

export function LightingCreatePage() {
  return <CatalogLightingFormPage mode="create" />;
}

export function LightingEditPage() {
  return <CatalogLightingFormPage mode="edit" />;
}
